<template>
  <article class="base-modal">
    <PulseLoader />
    <h1 class="loadding__title">{{ t('general.wait') }}</h1>
  </article>
</template>

<script setup lang="ts">
  import { useModalStore } from '@/stores/modal';
  import { useI18n } from 'vue-i18n';
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

  const { t } = useI18n();
  const modalStore = useModalStore();
</script>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  .base-modal {
    z-index: vars.$z-index-loading;
    flex-direction: column;
    .loadding__title {
      margin-top: 2.9851vw;
      color: #fff;
    }
  }
</style>
